import { render, staticRenderFns } from "./EnviosHoleriteIndividual.vue?vue&type=template&id=2493cab6"
import script from "./EnviosHoleriteIndividual.vue?vue&type=script&lang=js"
export * from "./EnviosHoleriteIndividual.vue?vue&type=script&lang=js"
import style0 from "./EnviosHoleriteIndividual.vue?vue&type=style&index=0&id=2493cab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports